import { useEffect } from 'react';

interface DocumentMeta {
  title: string;
  description: string;
  canonical?: string;
  ogImage?: string;
}

const BASE_URL = 'https://antz.ai';
const DEFAULT_OG_IMAGE = `${BASE_URL}/antz-logo.png`;

function setMetaTag(property: string, content: string, isProperty = false) {
  const attr = isProperty ? 'property' : 'name';
  let tag = document.querySelector(`meta[${attr}="${property}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute(attr, property);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
}

function setCanonical(href: string) {
  let link = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    document.head.appendChild(link);
  }
  link.setAttribute('href', href);
}

export function useDocumentMeta({ title, description, canonical, ogImage }: DocumentMeta) {
  useEffect(() => {
    const prevTitle = document.title;
    const metaDescription = document.querySelector('meta[name="description"]');
    const prevDescription = metaDescription?.getAttribute('content') ?? '';

    const canonicalUrl = canonical ?? `${BASE_URL}${window.location.pathname}`;
    const prevCanonical = document.querySelector<HTMLLinkElement>('link[rel="canonical"]')?.getAttribute('href') ?? '';

    const image = ogImage ?? DEFAULT_OG_IMAGE;

    document.title = title;

    if (metaDescription) {
      metaDescription.setAttribute('content', description);
    }

    setCanonical(canonicalUrl);

    setMetaTag('og:title', title, true);
    setMetaTag('og:description', description, true);
    setMetaTag('og:url', canonicalUrl, true);
    setMetaTag('og:image', image, true);

    setMetaTag('twitter:title', title);
    setMetaTag('twitter:description', description);
    setMetaTag('twitter:image', image);

    return () => {
      document.title = prevTitle;
      if (metaDescription) {
        metaDescription.setAttribute('content', prevDescription);
      }
      setCanonical(prevCanonical);
    };
  }, [title, description, canonical, ogImage]);
}
